import { useCallback, useMemo } from 'react';
import useMultipartMutation from './useMultipartMutation';

const buildFormData = (values: Record<string, unknown>) => {
    const data = new FormData();
    Object.keys(values).forEach(
        (key) => {
            const value = values[key];
            if (Array.isArray(value) && value.length > 0 && value[0] instanceof File) {
                value.forEach((file) => data.append(key, file));
            } else {
                data.append(key, value as any);
            }
        },
    );
    return data;
};

const useSendThreadMessage = ({
    agentId = '',
    threadId = '',
}: {
    agentId?: string;
    threadId?: string;
}) => {
    const {
        mutate: hookMutate,
        mutateAsync: hookMutateAsync,
        ...rest
    } = useMultipartMutation({
        pathname: `/agents/${agentId}/threads/${threadId}/send-message`,
        method: 'POST',
    });

    const mutate = useCallback(
        ({
            message,
            files,
        }: Record<string, unknown>) => hookMutate({
            body: buildFormData({
                text: message,
                attachedFiles: files,
            }),
        }),
        [hookMutate],
    );

    const mutateAsync = useCallback(
        ({
            message,
            files,
        }: Record<string, unknown>) => hookMutateAsync({
            body: buildFormData({
                text: message,
                attachedFiles: files,
            }),
        }),
        [hookMutateAsync],
    );

    return useMemo(() => ({ mutate, mutateAsync, ...rest }), [mutate, mutateAsync, rest]);
};

export default useSendThreadMessage;
